<template>
  <div class="active w1400">
    <div class="active-header font20">
      <span>当前位置：城市绿色配送 > 绩效考核</span>
      <div class="inputbox">
        <el-input placeholder="请输入内容" v-model="input9">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <div class="active-cont">
          <el-row>
          <el-col :span="6">
            <div class="silder">
              <div :class="[i==sliderTab?'silder-item font20 bold':'silder-item font20']"  v-for="(item,i) in childMenu" :key='i' @click="childTab(i)">
                {{item.ts002}}
                <span class="botline" v-show='i==sliderTab'></span>
              </div>
            </div>
          </el-col>
          <el-col :span="18">
             <div class="insturyChild">
                 <div class="insturyChild-item" v-for="(item,i) in service" @click="insuryGoInf(item)">
                     <div>
                       <img :src="[ item.ty004 ?item.ty004:require('../../assets/newsImg.png')]"  alt="详情图">
                     </div>
                     <div class="flexgroud">
                       <div class="font20 bold cleartext">{{item.ty002}}</div>
                       <div class="font16 grey cleartext">{{item.ty003}}</div>
                     </div>
                     <div class="look font20" @click="insuryGoInf(item)">
                       查看详情
                     </div>
                 </div>
                 <div class="page">
                    <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="currentPage"
                          :page-sizes="[5]"
                          :page-size="100"
                          layout="sizes, prev, pager, next, jumper"
                          :total="total">
                        </el-pagination>
                 </div>
             </div>
          </el-col>
          </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        sliderTab:0,
        childMenu:[{ts002:'绩效考核',quoteid:50}],
        input9:'',
        currentPage: 1,
        pageSize:5,
        total:100,
        service:[],
      }
    },
    created() {
      this.getNewsOftab();
    },
    watch:{
      input9(){
        this.currentPage=1;
        this.pageSize = 5;
        this.getNewsOftab();
      }
    },
    methods:{
     handleSizeChange(val) {
       this.pageSize = val;
       this.getNewsOftab();
     },
     handleCurrentChange(val) {
       this.currentPage = val;
       this.getNewsOftab();
     },
    getNewsOftab(){
       let search = this.input9 || '';
       if(search.trim().length<1){
         this.getData();
       }else{
         this.getsearchData();
       }
     },
     getsearchData(){
       this.$axios.post(`/api/news/list/${this.childMenu[this.sliderTab].quoteid}/search`, {
          skip:(this.currentPage-1)*this.pageSize,
          pageSize:this.pageSize,
          word:this.search
         }).then(res=>{
           this.service = res.data.data;
           this.total = res.data.count;
         })
     },
     getData(){
       this.$axios.post(`/api/news/list/${this.childMenu[this.sliderTab].quoteid}`, {
          skip:(this.currentPage-1)*this.pageSize,
          pageSize:this.pageSize,
         }).then(res=>{
           this.service = res.data.data;
           this.total = res.data.count;
         })
     },
     insuryGoInf(item){
       this.$router.push({name:'ActiveInf',params:{newsId:item.quoteid,pageId:this.childMenu[this.sliderTab]}})
     },
      childTab(i){
        this.sliderTab = i
      }
    }
  }
</script>

<style scoped>
  .active-header {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    height: 7rem;
    line-height: 7rem;
    padding: 0 2.7rem;
    background-color: #F6F5F5;
  }

  .inputbox {
    width: 21.6rem;
    line-height: normal;
  }

  .active-cont {
    width: 100%;
  }
  .silder{
    min-height: 94rem;
    background-color: #F6EEEE;
  }
  .silder-item{
    position: relative;
    height: 8.4rem;
    line-height: 8.4rem;
    text-align: center;
    font-size: 2rem;
    cursor: pointer;
    background-color: #f8f8f8;
    margin-bottom: 2px;
  }
  .botline{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 10.5rem;
    height: 3px;
    background-color: #0083CE;
  }
  .insturyChild{
    position: relative;
    width: 100%;
    min-height: 82.2rem;
    padding-bottom: 9.4rem;
  }
  .insturyChild-item{
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-left: 2.4rem;
    margin-top: 2.4rem;
    border: 1px solid #DCDCDC;
    border-radius: 0.4rem;
  }
  .insturyChild-item img{
    display: block;
    width: 17rem;
    height: 17rem;
    margin-right: 2.3rem;
  }
  .flexgroud{
    height: 17rem;
    flex: 1;
    max-width: 70rem;
  }
  .flexgroud>div:nth-child(1){
    margin: 1.2rem 0 2.4rem 0;
  }
  .look{
    width: 12rem;
  }
  .page{
    position: absolute;
    bottom: 3.8rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .grey{
    color: #9B9B9B;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/appraisal.vue